import { render } from "./CardFourtyTwo.vue?vue&type=template&id=f8eb9a48"
import script from "./CardFourtyTwo.vue?vue&type=script&lang=js"
export * from "./CardFourtyTwo.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__